export default (settings: any) => settings['treeViews'] * (1 / 60) * 10
